<form [formGroup]="changeForm" name="form" class="form" (ngSubmit)="onSubmit()" novalidate>
  <div class="form-group">
    <label class="rbv-label">New Password</label>
    <input type="password" formControlName="USER_PASSWORD" id="inputPassword" name="USER_PASSWORD" class="form-control rounded-0 rbv-field"
      placeholder="New Password" required
      [ngClass]="{'is-invalid': changeForm.controls['USER_PASSWORD'].invalid && (changeForm.controls['USER_PASSWORD'].dirty || changeForm.controls['USER_PASSWORD'].touched)}"/>

    <div class="invalid-feedback"
       *ngIf="changeForm.controls['USER_PASSWORD'].invalid && (changeForm.controls['USER_PASSWORD'].dirty || changeForm.controls['USER_PASSWORD'].touched)">
       <div *ngIf="changeForm.controls['USER_PASSWORD'].errors['pattern']">
         Password must be of 12 characters including at least 1 number and 1 capital letter</div>
     </div>
  </div>

  <div class="form-group">
    <label class="rbv-label">Retype Password</label>
    <input type="password" formControlName="USER_CONFIRM_PASSWORD" id="inputRetypePassword" name="USER_CONFIRM_PASSWORD" class="form-control rounded-0 rbv-field" placeholder="Confirm Password" required
    [ngClass]="{'is-invalid': changeForm.controls['USER_CONFIRM_PASSWORD'].invalid && (changeForm.controls['USER_CONFIRM_PASSWORD'].dirty || changeForm.controls['USER_CONFIRM_PASSWORD'].touched)}"/>

    <div class="invalid-feedback"
      *ngIf="changeForm.controls['USER_CONFIRM_PASSWORD'].invalid && (changeForm.controls['USER_CONFIRM_PASSWORD'].dirty || changeForm.controls['USER_CONFIRM_PASSWORD'].touched)">
      <div *ngIf="changeForm.controls['USER_CONFIRM_PASSWORD'].errors['minlength']">
        Password must be of 12 characters including at least 1 number and 1 capital letter</div>
      <div *ngIf="changeForm.controls['USER_CONFIRM_PASSWORD'].errors['compare']">
        Password did not match
      </div>
    </div>
  </div>

  <div class="actions horizontal wrap right">
    <button type="button" class="btn btn-rbv default" (click)="actionCancel()">Cancel</button>
    <button [disabled]="!changeForm.valid" type="submit" class="btn btn-rbv">Submit</button>
  </div>
</form>
